import React from "react";
import PlanningStrategyForm from "../components/forms/PlanningStrategyForm";

const PlanningStrategy: React.FC = () => {
  return (
   <>
   <PlanningStrategyForm />
   </>
  );
};

export default PlanningStrategy;
